import { render, staticRenderFns } from "./messageList.vue?vue&type=template&id=268b1b1e&scoped=true&"
import script from "./messageList.vue?vue&type=script&lang=js&"
export * from "./messageList.vue?vue&type=script&lang=js&"
import style0 from "./messageList.vue?vue&type=style&index=0&id=268b1b1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268b1b1e",
  null
  
)

component.options.__file = "messageList.vue"
export default component.exports